import React, {useEffect, useState} from 'react';
import {InfoDialog} from '../components/InfoDialog';
import {DataLlave} from '../../bussines/entities/EstadisticasLlave.entity';
import {useEstadisticasDsKey} from '../hooks/useEstadisticasDsKey';
import { CopyInfo } from '../components/CopyInfo';

const columns = [
   {
      name: 'ruc',
      label: 'DNI/RUC',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'razonsocial',
      label: 'Cliente',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'documento',
      label: 'Documento',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'codactivacion',
      label: 'Codigo Activación',
      options: {
         filter: true,
         display: 'true',
         customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
            let time = tableMeta.rowData[3];
            if (typeof time === 'string') {
               time = parseFloat(time.replace(/[^\d.-]/g, ''));
            }
            return <CopyInfo info={value} color="inherit" />;
         }
      }
   },
   {
      name: 'producto',
      label: 'Producto',
      options: {
         filter: true,
         display: 'true'
      }
   }
];

export const CardLlavesAnuladas: React.FC<{fecha:Date}> = ({fecha}) => {
   const [llavesAnuladasMes, setLlavesAnuladasMes] = useState<DataLlave[]>([]);
   const {getLlavesAnuladasMes} = useEstadisticasDsKey();
   const fetchLlavesAnuladas = async () => {
      const result = await getLlavesAnuladasMes({fecha: fecha});
      if (result) {
         setLlavesAnuladasMes(result);
      }
   };

   useEffect(() => {
      fetchLlavesAnuladas();
   }, []);
   return (
      <InfoDialog
         descripcion="Llaves anuladas en el mes"
         isCriticalValue
         list={llavesAnuladasMes}
         columns={columns}
      />
   );
};
